import { type APIConfiguration, Service, useGet, useList, useRead } from "@api/common";
import type { Gym, ListParams, ReadParams, UpdatePaymentMethodBody } from "./types";

export type { Gym };

export interface UpdateEmailDomainBody {
  emailDomain: string | null;
}

export class GymService extends Service<Gym> {
  constructor() {
    super("/gyms");
  }

  async updatePaymentMethod(gymId: string, body: UpdatePaymentMethodBody) {
    return this.put(`${this.basePath}/${gymId}/payment-method`, body);
  }

  async updateEmailDomain(gymId: string, body: UpdateEmailDomainBody): Promise<Gym> {
    return this.put(`${this.basePath}/${gymId}/email-domain`, body);
  }
}

export const gymService = new GymService();

export function useGyms(params?: ListParams<Gym>, config?: APIConfiguration) {
  return useList(gymService, params, config);
}

export function useGym(id: string | undefined, params?: ReadParams, config?: APIConfiguration) {
  return useRead(gymService, id, { populate: "phoneNumber emailDomain", ...params }, config);
}

export function useGymOptoutRate(id: string | undefined) {
  return useGet<{ rate: number }>(gymService, `${gymService.basePath}/${id}/optout-rate`);
}
